var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"76f8b79b0e4ca1eee4a98c5e9815149c5acc9acf"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ocm-client@gvm-tecnologia"]={id:"76f8b79b0e4ca1eee4a98c5e9815149c5acc9acf"};
      